<div class="settings-dialog">
  <div class="dialog-header" mat-dialog-title>
    <h2>
      <mat-icon>settings</mat-icon>
      {{ 'common.settings' | translate }}
    </h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Language Section -->
    <div class="settings-section">
      <h3>{{ 'settings.language' | translate }}</h3>
      <app-language-switcher></app-language-switcher>
      <div class="setting-item">
        <mat-form-field appearance="outline" class="language-field">
          <mat-label>{{ 'settings.selectLanguage' | translate }}</mat-label>
          <mat-select [(value)]="selectedLanguage" (selectionChange)="onLanguageChange($event.value)" id="language-select">
            <mat-option *ngFor="let lang of languages" [value]="lang.code">
              {{ lang.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Additional Settings (placeholder for future) -->
    <div class="settings-section">
      <h3>{{ 'settings.preferences' | translate }}</h3>
      <p class="settings-note">{{ 'settings.moreSettings' | translate }}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">
      {{ 'common.close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
